export const EVENTS = 'events';
export const ACTION_LISTS = 'actionLists';
export const KEEP_ACTIVE = 'keepActive';
export const INTERACTIONS = 'interactions';
export const SELECTED_ACTION_LIST_ID = 'selectedActionListId';
export const SELECTED_INTERACTION_ID = 'selectedInteractionId';
export const SELECTED_TARGET_INDEX = 'selectedTargetIndex';
export const SELECTED_ACTION_ITEM_IDS = 'selectedActionItemIds';
export const USE_FIRST_GROUP_AS_INITIAL_STATE = 'useFirstGroupAsInitialState';
export const IX2_NODE_ID_MAP = 'nodeIdMap';
export const RELINK_MODE = 'relinkMode';
export const STAGED_ACTION_LIST = 'stagedActionList';
export const ACTION_ITEM_IS_EPHEMERAL = 'actionItemIsEphemeral';
export const SELECTED_INTERACTION_ELEMENT_ID = 'selectedInteractionElementId';
export const INITIAL_FOCUSED_SYMBOL_NATIVE_ID_PATH =
  'initialFocusedSymbolNativeIdPath';
export const INITIAL_SELECTED_NODE_IN_INSTANCE_NATIVE_ID_PATH =
  'initialSelectedNodeInInstanceNativeIdPath';
export const BASE_ACTION_LIST_IDS = 'baseActionListIds';
export const BASE_EVENT_IDS = 'baseEventIds';
export const BASE_INTERACTION_IDS = 'baseInteractionIds';
export const BRANCH_ID = 'branchId';

export const EVENT_PREFIX = 'e';
export const INTERACTION_PREFIX = 'i';
export const ACTION_PREFIX = 'a';
export const PARAMETER_GROUP_PREFIX = 'p';
export const ACTION_ITEM_PREFIX = 'n';
